module.exports = __webpack_public_path__ + "static/media/Jose_Antonio_Cabrera_Roman.4953ebef.png";